import { Outlet, createFileRoute } from '@tanstack/react-router';

import Themes from 'component/view/SiteDetails/Themes';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/themes')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.themes(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: ThemesLayout,
});

function ThemesLayout() {
  return (
    <Themes>
      <Outlet />
    </Themes>
  );
}
